module.exports = __webpack_public_path__ + "img/system_bj2.5655410f.png";